import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { hasPermission, PERMISSIONS } from '@/lib/permissions';
import { useChurchStore } from '@/stores/church-store';
import { cn } from '@/utils/cn';

export const AttendanceSubnav = () => {
  const { t } = useTranslation('attendance');
  const membership = useChurchStore((state) => state.membership);
  const canManageKiosks = hasPermission(membership, PERMISSIONS.ATTENDANCE_MANAGE_KIOSKS);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      'rounded-md px-3 py-1.5 text-body-sm transition-colors',
      isActive
        ? 'bg-brand/10 font-medium text-brand'
        : 'text-fg-secondary hover:bg-surface-sunken hover:text-fg',
    );

  return (
    <nav className="mb-4 flex flex-wrap gap-2" aria-label={t('title')}>
      <NavLink to="/attendance" end className={linkClass}>
        {t('sessions.title')}
      </NavLink>
      {canManageKiosks ? (
        <NavLink to="/attendance/kiosks" className={linkClass}>
          {t('kiosks.title')}
        </NavLink>
      ) : null}
    </nav>
  );
};
